<template>
  <v-container>
    <div id="forgotpassword" style="height: 100%">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <v-card elevation="12" style="margin-top: calc(50vh - 268px)">
            <v-progress-linear
              :active="!loaded"
              indeterminate
              absolute
              top
            ></v-progress-linear>
            <v-card-text style="padding: 40px 40px 40px 40px">
              <div class="text-center mb-4">
                <img
                  src="../assets/logo.png"
                  alt="Bryggeriforeningen"
                  style="width: 240px; height: auto"
                />
              </div>

              <div v-show="!forgotPasswordCompleted">
                <div class="mb-5">
                  Indtast email adresse for at påbegynde nulstillelse af
                  adgangskode.
                </div>
                <v-form ref="form" v-model="valid" @submit.prevent="onSubmit">
                  <v-text-field
                    label="Email"
                    placeholder="Enter email address"
                    name="email"
                    class="mb-6"
                    type="text"
                    required
                    :rules="[requiredRule, emailRule]"
                    v-model="form.email"
                  ></v-text-field>

                  <v-btn
                    class="primary"
                    type="submit"
                    large
                    min-width="200"
                    block
                    >Nulstil adgangskode</v-btn
                  >

                  <v-btn
                    type="submit"
                    class="primary--text mt-4"
                    text
                    large
                    min-width="200"
                    block
                    @click="onCancelClick"
                    >Annuller</v-btn
                  >
                </v-form>
              </div>

              <div v-show="forgotPasswordCompleted">
                <div class="mb-6">
                  Hvis kontoen findes i systemet sendes en mail til
                  <strong>{{ forgotPasswordCompleted }}</strong
                  >, med instruktioner til at nulstille kontoens adgangskode.<br /><br /><em
                    >Hvis du ikke har modtaget en email indenfor 5 minutter, så
                    check venligst din spam-mappe.</em
                  ><br /><br />
                </div>
                <v-btn
                  class="primary"
                  type="button"
                  large
                  min-width="200"
                  block
                  @click="onBackToLoginClick"
                  >Tilbage til log ind</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, email } from "../utils/FormRules.js";

export default {
  name: "ForgotPassword",
  components: {},
  data: () => ({
    valid: false,
    form: {
      email: "",
    },
    requiredRule: required,
    emailRule: email,
  }),
  methods: {
    onSubmit() {
      const valid = this.$refs.form.validate();
      if (valid) {
        this.forgotPassword(this.form.email);
      }
    },
    onCancelClick() {
      this.$router.replace("/login");
    },
    onBackToLoginClick() {
      this.$router.replace("/login");
    },
    ...mapActions(["forgotPassword"]),
  },
  computed: {
    ...mapState(["loaded", "forgotPasswordCompleted"]),
  },
};
</script>
